// Console override MUST be imported first (before any other imports)
// This suppresses excessive debug logs in production while preserving critical logs
import './utils/consoleOverride';

// Patch ResizeObserver before any observers are created (MUI inputs, etc.)
import './utils/resizeObserverFix';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './AuthContext';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import ScrollRestoration from './components/common/ScrollRestoration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ScrollRestoration />
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </HelmetProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
